import script from "./DashboardCards.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCards.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCards.vue?vue&type=style&index=0&id=2addc16b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2addc16b"]])

export default __exports__